if (!customElements.get('menu-slideout')) {
  const selectors = {
    activeClass: 'is-active',
    menuActiveClass: 'menu-active',
    panelSelector: '.js-menu-panel',
    menuOpenerSelector: '.js-menu-slideout-opener',
    closerPanelSelector: '.js-menu-panel-closer',
    triggerSelector: '.js-menu-slideout-trigger',
    scrollableSelector: '[data-scrollable]',
    headerSelector: '.js-header',
    announcementBarSelector: '#shopify-section-announcement',
    headerGroupBtn: '.js-header-group-btn',
    MENU_SLIDEOUT_TABS_SELECTOR: '.js-menu-slideout-tabs',
    MENU_SLIDEOUT_LIST_SELECTOR: '.js-menu-slideout-list',
    MENU_SLIDEOUT_ACCORDION_SELECTOR: '.js-submenu-slideout__item-accordion',
    MENU_SLIDEOUT_ITEM: '.js-submenu-slideout__item-link',
    HIDDEN_CLASS: 'hidden',
    SHOW_CLASS: 'is-show',
    MENU_BOTTOM_SELECTOR: '.js-menu-bottom',
    ACTIVE_SCROLL_CLASS: 'active-scroll',
    HEADER_LOGO: '.header-logo'
  }

  class MenuSlideout extends HTMLElement {
    constructor () {
      super()

      this.items = document.querySelectorAll(selectors.MENU_SLIDEOUT_ITEM)
      this.triggerEls = document.querySelectorAll(selectors.triggerSelector)
      this.scrollableEls = Array.from(this.querySelectorAll(selectors.scrollableSelector))
      this.header = document.querySelector(selectors.headerSelector)
      this.shopifyAnnouncementBar = document.querySelector(selectors.announcementBarSelector)
      this.headerGroupBtn = document.querySelector(selectors.headerGroupBtn)
      this.btnSearch = document.getElementById('search-button')
      this.menuSlideoutTabs = this.querySelector(selectors.MENU_SLIDEOUT_TABS_SELECTOR)
      this.menuSlideoutList = this.querySelector(selectors.MENU_SLIDEOUT_LIST_SELECTOR)
      this.menuSlideoutAccordion = this.querySelectorAll(selectors.MENU_SLIDEOUT_ACCORDION_SELECTOR)
      this.menuBottomEl = document.querySelector(selectors.MENU_BOTTOM_SELECTOR)
      this.topOffsetMenuBottom = this.menuBottomEl ? Math.abs(window.innerHeight - this.menuBottomEl.clientHeight) : 0
      this.topOffsetMenuBottomScroll = this.topOffsetMenuBottom + 10
      this.closeMenuFunc = this.closeMenu

      this.states = {
        open: false
      }

      this.attachEvents()
    }

    attachEvents() {
      if (this.triggerEls.length > 0) {
        this.triggerEls.forEach((trigger) => {
          trigger.addEventListener('click', (e) => {
            e.preventDefault()
            if (this.states.open) {
              this.closeMenu()
              this.headerGroupBtn.style.display = 'flex'
            } else {
              this.openMenu()
              this.headerGroupBtn.style.display = 'none'
            }

            if (trigger.classList.contains('data-scroll')) {
              this.classList.add(selectors.ACTIVE_SCROLL_CLASS)
              document.scrollingElement.scrollTo({
                top: this.topOffsetMenuBottomScroll,
                behavior: 'smooth'
              })
            }
          })
        });
      }

      this.activeMenuLink()

      this.items.forEach(item => {
        item.addEventListener('click', () => {
          this.closeMenu()
          const href = item.getAttribute('href')
          
          if (href.includes('#') && href !== '#') {
            const targetSelector = href.split('#')[1];
            const targetElement = document.querySelector(`.${targetSelector}`)
            const scrollOffset = targetElement.offsetTop - 130;
            
            if (targetElement) {
              window.scrollTo({
                top: scrollOffset,
                behavior: 'smooth'
              })
            }
          }
        })
      })

      window.addEventListener('scroll', () => {
        document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
      })
    }

    activeMenuLink() {
      if (this.menuSlideoutTabs && this.menuSlideoutTabs.children.length > 0) {
        for (let i = 0; i < this.menuSlideoutTabs.children.length; i++) {
          this.menuSlideoutTabs.children[i].addEventListener(
            'click',
            () => {
              Array.from(this.menuSlideoutTabs.children).forEach(element => {
                if (element.children[0].children[0].classList.contains(selectors.activeClass)) {
                  element.children[0].children[0].classList.remove(selectors.activeClass)
                }
              })
              Array.from(this.menuSlideoutList.children).forEach(element => {
                if (element.classList.contains(selectors.SHOW_CLASS)) {
                  element.classList.remove(selectors.SHOW_CLASS)
                }

                if (!element.classList.contains(selectors.HIDDEN_CLASS)) {
                  element.classList.add(selectors.HIDDEN_CLASS)
                }
              })
              this.menuSlideoutList.children[i].classList.remove(selectors.HIDDEN_CLASS)
              this.menuSlideoutTabs.children[i].children[0].children[0].classList.add(selectors.activeClass)
              this.menuSlideoutList.children[i].classList.add(selectors.SHOW_CLASS)
            }
          )
        }
      }
    }

    bindItemEvents(item) {
      const opener = item.querySelectorAll(selectors.menuOpenerSelector)
      const panel = item.querySelector(selectors.panelSelector)

      if (opener && panel) {
        this.bindPanelEvents(panel)
        opener.forEach(item => {
          item.addEventListener('click', (e) => {
            e.preventDefault()
            this.openPanel(panel)
          })
        })
      }

    }

    bindPanelEvents(panel) {
      const closer = panel.querySelector(selectors.closerPanelSelector)

      if (closer) {
        closer.addEventListener('click', (e) => {
          e.preventDefault()
          this.closePanel(panel)
        })
      }
    }

    openMenu () {
      this.classList.remove('hidden')
      setTimeout(() => {
        this.classList.add(selectors.activeClass)
        this.states.open = true
        this.header.classList.add(selectors.menuActiveClass)
        this.shopifyAnnouncementBar.classList.add('hidden-bar')

        const headerLogo = document.querySelector(selectors.HEADER_LOGO)

        if (headerLogo) {
          headerLogo.classList.add('transition-none')
          headerLogo.style.opacity = 0
        }

        if (this.triggerEls.length > 0) {
          this.triggerEls.forEach((trigger) => {
            trigger.setAttribute('aria-expanded', true)
          });
        }
        const scrollY = document.documentElement.style.getPropertyValue('--scroll-y')
        const body = document.body
        body.style.position = 'fixed'
        body.style.top = `-${scrollY}`
        body.style.width = '100%'
      })
    }

    closeMenu () {
      this.classList.remove(selectors.ACTIVE_SCROLL_CLASS)
      this.classList.remove(selectors.activeClass)
      this.states.open = false
      this.shopifyAnnouncementBar.classList.remove('hidden-bar')
      const body = document.body;
      const scrollY = body.style.top;
      body.style.position = '';
      body.style.top = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);

      const headerLogo = document.querySelector(selectors.HEADER_LOGO)
      if (headerLogo) {
        headerLogo.classList.remove('transition-none')
        headerLogo.style.opacity = 1
      }

      if (this.triggerEls.length > 0) {
        this.triggerEls.forEach((trigger) => {
          trigger.setAttribute('aria-expanded', false)
        });
      }

      if (this.menuSlideoutAccordion.length > 0) {
        this.menuSlideoutAccordion.forEach((item) => {
          const buttonEl = item.querySelector('button[type="button"')
          const contentEl = item.querySelector('.accordion-item__content')
          buttonEl?.classList.remove('active')
          buttonEl?.setAttribute('aria-expanded', false)
          contentEl?.removeAttribute('style')
        })
      }

      if (this.header.classList.contains('js-transparent-slow')) {
        setTimeout(() => {
          this.header.classList.remove(selectors.menuActiveClass)
        }, 500)
      } else {
        this.header.classList.remove(selectors.menuActiveClass)
      }

      setTimeout(() => {
        this.classList.add('hidden')
      }, 300)
    }

    openPanel (el) {
      el.classList.add(selectors.activeClass)
    }

    closePanel (el) {
      el.classList.remove(selectors.activeClass)
    }
  }

  customElements.define('menu-slideout', MenuSlideout)
}
